// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `v-fileUpload-list {
  display: grid;
}
v-fileUpload-list > .selected-file-list {
  display: flex;
  gap: var(--file-upload-list-gap-default);
}
v-fileUpload-list > .selected-file-list.orientation-vertical {
  flex-direction: column;
}
v-fileUpload-list > .selected-file-list.orientation-horizontal {
  flex-direction: row;
}
v-fileUpload-list > .selected-file-list.orientation-mixed {
  flex-direction: row;
  flex-wrap: wrap;
}

.v-fileUpload-item {
  -webkit-user-select: none;
          user-select: none;
  display: flex;
  border-width: var(--file-upload-list-border-width);
  border-style: var(--file-upload-list-border-style);
  border-color: var(--file-upload-list-border-color);
  background: var(--file-upload-list-background);
  min-height: 100px;
}
.v-fileUpload-item:hover {
  border-color: var(--file-upload-list-border-hover-color);
}
.v-fileUpload-item .drag-buttons {
  align-items: center;
  width: var(--file-upload-list-width);
  padding: var(--file-upload-list-drag-buttons-padding);
  color: var(--file-upload-list-drag-buttons-color);
  background: var(--file-upload-list-drag-buttons-background);
}
.v-fileUpload-item .file {
  display: flex;
  width: var(--file-upload-list-width-full);
  padding: var(--file-upload-list-padding);
  gap: var(--file-upload-list-gap-large);
}
.v-fileUpload-item .file .file-preview {
  height: auto;
  width: auto;
  object-fit: contain;
  max-width: 150px;
  max-height: 80px;
  object-fit: contain;
  object-position: center;
  align-self: center;
  overflow: hidden;
}
.v-fileUpload-item .file .file-details {
  flex-grow: 1;
}
.v-fileUpload-item .grip-icon {
  cursor: grab !important;
}
.v-fileUpload-item v-icon:hover {
  color: var(--file-upload-list-icon-color);
}`, "",{"version":3,"sources":["webpack://./src/app/modules/wrappers/lib/fileUpload-list/fileUpload-list.component.sass"],"names":[],"mappings":"AAAA;EACE,aAAA;AACF;AACE;EACE,aAAA;EACA,wCAAA;AACJ;AACQ;EACI,sBAAA;AACZ;AAAQ;EACI,mBAAA;AAEZ;AADQ;EACI,mBAAA;EACA,eAAA;AAGZ;;AADA;EACI,yBAAA;UAAA,iBAAA;EACA,aAAA;EACA,kDAAA;EACA,kDAAA;EACA,kDAAA;EACA,8CAAA;EACA,iBAAA;AAIJ;AAHI;EACI,wDAAA;AAKR;AAFI;EACI,mBAAA;EACA,oCAAA;EACA,qDAAA;EACA,iDAAA;EACA,2DAAA;AAIR;AAFI;EACI,aAAA;EACA,yCAAA;EACA,wCAAA;EAEA,sCAAA;AAGR;AADQ;EACI,YAAA;EACA,WAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,gBAAA;AAGZ;AADQ;EACI,YAAA;AAGZ;AADI;EACI,uBAAA;AAGR;AADQ;EACI,yCAAA;AAGZ","sourcesContent":["v-fileUpload-list\n  display: grid\n\n  > .selected-file-list\n    display: flex\n    gap: var(--file-upload-list-gap-default)\n    &.orientation\n        &-vertical\n            flex-direction: column\n        &-horizontal\n            flex-direction: row\n        &-mixed\n            flex-direction: row\n            flex-wrap: wrap\n    \n.v-fileUpload-item\n    user-select: none\n    display: flex\n    border-width: var(--file-upload-list-border-width)\n    border-style: var(--file-upload-list-border-style)\n    border-color: var(--file-upload-list-border-color)\n    background: var(--file-upload-list-background)\n    min-height: 100px\n    &:hover\n        border-color: var(--file-upload-list-border-hover-color)\n\n\n    .drag-buttons\n        align-items: center\n        width: var(--file-upload-list-width)\n        padding: var(--file-upload-list-drag-buttons-padding)\n        color: var(--file-upload-list-drag-buttons-color)\n        background: var(--file-upload-list-drag-buttons-background)\n\n    .file\n        display: flex\n        width: var(--file-upload-list-width-full)\n        padding: var(--file-upload-list-padding)\n        // padding: 1rem\n        gap: var(--file-upload-list-gap-large)\n\n        .file-preview\n            height: auto\n            width: auto\n            object-fit: contain\n            max-width: 150px\n            max-height: 80px\n            object-fit: contain\n            object-position: center\n            align-self: center\n            overflow: hidden\n\n        .file-details\n            flex-grow: 1\n\n    .grip-icon\n        cursor: grab !important\n    v-icon\n        &:hover\n            color: var(--file-upload-list-icon-color)\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
